import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
interface DotsProps {
  count: number;
  activeItemIndex: number;
  onDotClick?: (index: number) => void;
}
const Dots: FC<DotsProps> = ({
  count,
  activeItemIndex,
  onDotClick
}) => <DotsWrapper>
    {new Array(count).fill('').map((_, index) => <Dot key={index} isActive={index === activeItemIndex} onClick={() => onDotClick?.(index)} />)}
  </DotsWrapper>;
export default Dots;
const DotsWrapper = /*#__PURE__*/styled('div')({
  name: "DotsWrapper",
  class: "d1r0gjj5",
  propsAsIs: false
});
interface DotProps {
  isActive: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? theme.colors.icon.accent : theme.colors.icon.tertiary;
const Dot = withTheme(/*#__PURE__*/styled('div')({
  name: "Dot",
  class: "ds5199o",
  propsAsIs: false,
  vars: {
    "ds5199o-0": [_exp()]
  }
}));

require("./Dots.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Dots.tsx");